export default __webpack_public_path__ + "static/media/philanthropy.f9ada8a5.svg";